

import React, { useEffect, useRef, useState, useMemo, useCallback } from 'react';
import { APIProvider, Map, AdvancedMarker, useMap, Pin } from '@vis.gl/react-google-maps';

const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const calculateBoundsAndCenter = (addresses) => {
    if (!addresses || addresses.length === 0) return { center: { lat: 0, lng: 0 }, bounds: null };

    const latitudes = addresses.map((address) => address.latitude);
    const longitudes = addresses.map((address) => address.longitude);

    const minLat = Math.min(...latitudes);
    const maxLat = Math.max(...latitudes);
    const minLng = Math.min(...longitudes);
    const maxLng = Math.max(...longitudes);

    const center = {
        lat: (minLat + maxLat) / 2,
        lng: (minLng + maxLng) / 2
    };

    const bounds = {
        north: maxLat,
        south: minLat,
        east: maxLng,
        west: minLng
    };

    return { center, bounds };
};

const MarkerMap = ({ addresses }) => {
    const map = useMap();
    const { center, bounds } = useMemo(() => calculateBoundsAndCenter(addresses), [addresses]);

    useEffect(() => {
        if (map) {
            if (addresses.length === 1) {
                map.setCenter(center);
                map.setZoom(13);
            } else if(bounds) {

                const googleBounds = new window.google.maps.LatLngBounds(
                    { lat: bounds.south, lng: bounds.west },
                    { lat: bounds.north, lng: bounds.east }
                );
                
                map.fitBounds(googleBounds, {
                    padding: {top: 50,right: 50,bottom: 50,left: 50}});
            }
        }
    }, [map, bounds]);

    return (
        <div style={{ height: '400px', width: '100%' }}>
            <Map defaultZoom={13} defaultCenter={center} mapId="a6d46d417d80bc11" mapTypeId="roadmap">
                {addresses.map(({ id, latitude, longitude }) => (
                    <AdvancedMarker key={id} position={{ lat: latitude, lng: longitude }}>
                        <Pin background={'#FBBC04'} glyphColor={'#000'} borderColor={'#000'} />
                    </AdvancedMarker>
                ))}
            </Map>
        </div>
    );
};

const AddressMap = ({ addresses }) => {
    return (
        <APIProvider apiKey={apiKey}>
            <MarkerMap addresses={addresses}/>
        </APIProvider>
    );
};

export default AddressMap;